const AddButton = ({ onClick, text, disabled }) => {
    return (
      <button 
        type="button"
        className="btn btn-primary mb-3" 
        onClick={onClick}
        disabled={disabled}
      >
        <i className="fas fa-plus me-2"></i>
        {text}
      </button>
    );
  };

export default AddButton;  